export const fetchCostServices = async (token: string, year: number) => {
  if (!token) 
    return;
    try {
      //const response = await fetch(`https://4np1ake7e3.execute-api.us-east-2.amazonaws.com/Prod/AWS-ECS-Services/PROD`, {
      const response = await fetch(`https://5286pb88cb.execute-api.us-east-2.amazonaws.com/prod/aws-ecs-services/count`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        },
      });

      if (!response.ok) throw new Error("Failed to fetch API data");

      const jsonResponse = await response.json();
      console.log("Raw API Response:", jsonResponse);
      if (jsonResponse?.task_counts) 
      {
        return jsonResponse;
      } 
      else 
      {
        console.error("Unexpected data format:", jsonResponse);
        return [];
      }
    } 
    catch (error) 
    {
      console.error("Error fetching API data:", error);
    }
  };
